import React, { useEffect, useState } from "react";
import axios from "axios";
import './Consular.css'; // make sure CSS is imported

const LibaUsers = () => {
    const [users, setUsers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [updateValues, setUpdateValues] = useState({});

    const fetchUsers = async () => {
        setLoading(true);
        try {
            const response = await axios.post(
                "https://api.theleadsense.com/api/v1/liba-users"
            );
            if (response.data && response.data.data) {
                setUsers(response.data.data);
            }
        } catch (err) {
            setError(err.message || "Failed to fetch users");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchUsers();
    }, []);

    const handleChange = (userId, field, value) => {
        setUpdateValues(prev => ({
            ...prev,
            [userId]: {
                ...prev[userId],
                [field]: value ? parseInt(value, 10) : 0,
            },
        }));
    };

    const handleUpdate = async (userId) => {
        const payload = {
            id: userId,
            progress: updateValues[userId]?.progress ?? users.find(u => u.id === userId).progress,
            payments_pgdm: updateValues[userId]?.pgdm ?? users.find(u => u.id === userId).payments_pgdm,
            payments_pgp: updateValues[userId]?.pgp ?? users.find(u => u.id === userId).payments_pgp,
            payments_ggu: updateValues[userId]?.ggu ?? users.find(u => u.id === userId).payments_ggu,
            payments_ed: updateValues[userId]?.ed ?? users.find(u => u.id === userId).payments_ed,
            registrations_pgdm: updateValues[userId]?.registrations_pgdm ?? users.find(u => u.id === userId).registrations_pgdm,
            registrations_pgp: updateValues[userId]?.registrations_pgp ?? users.find(u => u.id === userId).registrations_pgp,
            registrations_ggu: updateValues[userId]?.registrations_ggu ?? users.find(u => u.id === userId).registrations_ggu,
            registrations_ed: updateValues[userId]?.registrations_ed ?? users.find(u => u.id === userId).registrations_ed,
        };
        console.log('kskldkdd',payload)

        try {
            const response = await axios.post("https://api.theleadsense.com/api/v1/liba-users", payload);
            if (response.data?.status === 200) {
                alert("User updated successfully!");
                fetchUsers();
                setUpdateValues(prev => ({ ...prev, [userId]: {} }));
            }
        } catch (err) {
            alert(err.response?.data?.message || "Failed to update user");
        }
    };


    if (loading) return <p className="loading-text">Loading users...</p>;
    if (error) return <p className="error-text">Error: {error}</p>;

    return (
        <div className="liba-users-container">
            <h2 className="heading">Liba Users</h2>
            <div className="table-container">
                <table className="users-table">
                    <thead>
                        <tr>
                            <th>Image</th>
                            <th>Name</th>
                            <th>Progress</th>
                            <th>Payments PGDM</th>
                            <th>Payments PGP</th>
                            <th>Payments GGU</th>
                            <th>Payments ED</th>
                            <th>Payments Total</th>
                            <th>Registrations PGDM</th>
                            <th>Registrations PGP</th>
                            <th>Registrations GGU</th>
                            <th>Registrations ED</th>
                            <th>Registrations Total</th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {users.map((user, index) => (
                            <tr key={user.id} className={`user-row ${index % 2 === 0 ? 'even-row' : 'odd-row'}`}>
                                <td>
                                    <img src={user.img} alt={user.name} className="user-image" />
                                </td>
                                <td className="name-cell">{user.name}</td>

                                {/* Progress */}
                                <td>
                                    <input
                                        type="number"
                                        value={updateValues[user.id]?.progress ?? user.progress}
                                        onChange={e => handleChange(user.id, "progress", e.target.value)}
                                        className="input-cell"
                                    />
                                </td>

                                {/* Payments */}
                                {["pgdm", "pgp", "ggu", "ed"].map(field => (
                                    <td key={`payment-${field}`}>
                                        <input
                                            type="number"
                                            value={updateValues[user.id]?.[field] ?? user[`payments_${field}`]}
                                            onChange={e => handleChange(user.id, field, e.target.value)}
                                            className="input-cell"
                                        />
                                    </td>
                                ))}
                                <td className="total-cell">{user.payments_total}</td>

                                {/* Registrations */}
                                {["pgdm", "pgp", "ggu", "ed"].map(field => (
                                    <td key={`reg-${field}`}>
                                        <input
                                            type="number"
                                            value={updateValues[user.id]?.[`registrations_${field}`] ?? user[`registrations_${field}`]}
                                            onChange={e => handleChange(user.id, `registrations_${field}`, e.target.value)}
                                            className="input-cell"
                                        />
                                    </td>
                                ))}
                                <td className="total-cell">{user.registrations_total}</td>

                                <td>
                                    <button className="update-button" onClick={() => handleUpdate(user.id)}>Update</button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default LibaUsers;
